<template>
	<section id="intro" class="main-content">
		<div class="row">
			<slot name="content">
				<div class="columns column6">
					<h4 v-if="subtitle" class="subtitle">
						{{ subtitle }}
					</h4>
					<h1>{{ title }}</h1>
					<div v-parse-links v-html="content" />
				</div>
			</slot>
			<slot name="right-content">
				<div v-parse-links class="columns column6" v-html="rightContent" />
			</slot>
			<slot />
		</div>
		<slot name="extra-content" />
	</section>
</template>

<script setup>
defineProps({
	title: { type: String, default: '' },
	subtitle: { type: String, default: '' },
	content: { type: String, default: '' },
	rightContent: { type: String, default: '' },
});
</script>

<style lang="scss" scoped>
.main-content {
	.subtitle {
		font-weight: 400;
		font-size: 16px;
		color: #42737c;
		font-family: $body-font-family;
		letter-spacing: 2px;
		text-transform: uppercase;
		padding-left: 84px;
		position: relative;

		&::before {
			content: '';
			display: block;
			position: absolute;
			top: calc((50%) - 2px);
			left: 0;
			width: 70px;
			height: 4px;
			background: #42737c;
		}
	}
}

@media (max-width: 960px) {
	.column6 {
		padding: 25px;
	}

	#intro .column6 {
		padding: 25px 25px 0;

		&:last-child {
			padding: 0 25px 25px;
		}
	}
}
</style>
